import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DepartmentsState } from '../reducers/departments.reducer';
import { DEPARTMENTS_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<DepartmentsState>(DEPARTMENTS_FEATURE_KEY);

export const selectDepartments = createSelector(selectState, (state: DepartmentsState) => state.departments);
export const selectLoaded = createSelector(selectState, (state: DepartmentsState) => state.loaded);
export const selectLoading = createSelector(selectState, (state: DepartmentsState) => state.loading);
export const selectValue = createSelector(selectState, (state: DepartmentsState) => state.value);
export const selectTotal = createSelector(selectState, (state: DepartmentsState) => state.total);
export const selectLookupLoaded = createSelector(selectState, (state: DepartmentsState) => state.lookupLoaded);
export const selectLookupLoading = createSelector(selectState, (state: DepartmentsState) => state.lookupLoading);
export const selectLookup = createSelector(selectState, (state: DepartmentsState) => state.lookup);
